<template lang="pug">
.upload-file
  el-row(style="line-height: 20px")
    el-col(:span="4" :class="{required: isRequired}") {{ $t(text) }}
    el-col(:span="20")
      a.file-name(
        v-if="fileName && !canEdit"
        :href="downloadUrl"
        target="_blank"
      ) {{ fileName }}
      .upload-file__edit(v-else)
        el-upload(
          :disabled="disabled"
          action="组件必传项，无意义"
          :http-request="upload"
          :show-file-list="false"
          :multiple="true"
        )
          el-button(
            :disabled="disabled"
            type="primary",
          ) {{ $t('点击上传') }}
        a(
          v-if="editFilePath != null"
          :href="editFilePath"
          style="margin-left: 10px"
          target="_blank"
        ) {{ editFileName }}
        span(v-else)
</template>

<script>
import axios from 'axios'

export default {
  props: {
    isRequired: {
      type: Boolean,
      default () {
        return true
      }
    },
    axiosUrl: {
      type: String,
      isRequired: true,
      default () {
        return ''
      }
    },
    params: {
      type: Object,
      isRequired: false,
      default () {
        return {}
      }
    },
    text: {
      type: String,
      isRequired: true,
      default () {
        return ''
      }
    },
    fileName: {
      type: String,
      isRequired: false,
      default () {
        return null
      }
    },
    downloadUrl: {
      type: String,
      isRequired: false,
      default () {
        return null
      }
    },
    canEdit: {
      type: Boolean,
      isRequired: false,
      default () {
        return false
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      editFileName: '',
      editFilePath: null
    }
  },
  watch: {
    downloadUrl () {
      if (this.canEdit && this.downloadUrl != null) {
        this.editFilePath = this.downloadUrl
        this.editFileName = this.fileName
      }
    }
  },
  mounted () {
    this.editFilePath = this.downloadUrl
    this.editFileName = this.fileName
  },
  methods: {
    upload (inst) {
      const formData = new window.FormData()
      formData.append('file', inst.file)
      if (Object.keys(this.params).length !== 0) {
        for (var key in this.params) {
          formData.append(key, this.params[key])
        }
      }
      this.$emit('uploading')
      axios
        .post(this.axiosUrl, formData)
        .then((res) => {
          this.$emit('success', res)
          this.editFileName = inst.file.name
          this.editFilePath = res.file_download_path || res.brief_path
          this.$message.success(this.$t('提交成功'))
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.upload-file__edit
  display flex
  align-items center
  > span
    margin-left 10px

.file-name
  display inline-block
  width 200px
  white-space nowrap
  text-overflow ellipsis
  overflow hidden
</style>
